<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M4.63737 3.20523C4.46409 3.15489 4.28041 3.15237 4.10581 3.19795C3.93121 3.24353 3.7722 3.33551 3.64563 3.46412C3.51907 3.59274 3.42966 3.75321 3.38689 3.92852C3.34412 4.10383 3.34959 4.28744 3.40271 4.4599L6.64537 14.9999H18C18.2653 14.9999 18.5196 15.1053 18.7071 15.2928C18.8947 15.4803 19 15.7347 19 15.9999C19 16.2651 18.8947 16.5195 18.7071 16.707C18.5196 16.8945 18.2653 16.9999 18 16.9999H6.64537L3.40271 27.5399C3.3499 27.7123 3.34468 27.8957 3.38759 28.0708C3.43049 28.2459 3.51994 28.4062 3.64646 28.5346C3.77297 28.663 3.93186 28.7549 4.10629 28.8004C4.28073 28.8459 4.46423 28.8434 4.63737 28.7932C13.4573 26.2283 21.7746 22.1763 29.2307 16.8119C29.3596 16.7193 29.4645 16.5973 29.5369 16.4562C29.6093 16.315 29.647 16.1586 29.647 15.9999C29.647 15.8412 29.6093 15.6848 29.5369 15.5436C29.4645 15.4024 29.3596 15.2805 29.2307 15.1879C21.7747 9.82296 13.4574 5.7705 4.63737 3.20523Z"
      fill="#6C7C9D"
    />
  </svg>
</template>
